import React from 'react';
import { useSelector } from 'react-redux';
import LicenseMetrics from '../licenseMetrics';
import TimelineComponent from '../graphComponents/timelineComponent';
import RankingComponent from '../graphComponents/rankingComponent';
import ROIComponent from '../graphComponents/ROIComponent';
import BenchMarkingComponent from '../graphComponents/benchMarkingComponent';
import './FinancePageLayout.css';
import {
  getTotalAcademySpend,
  getAcademyProfitability,
  getClubSpendOnAcademy,
  getClubValue,
  getYoyValues,
} from '../licenseAnalyticsSupport/getLicenseAnalyticsActions';
import { useTranslation } from 'react-i18next';
import { PAGE } from '../licenseAnalyticsSupport/typeInterfaces';

const FinanceLayoutPage = React.memo(() => {
  const academySpend = useSelector(getTotalAcademySpend);
  const clubSpendonAcademy = useSelector(getClubSpendOnAcademy);
  const academyProfit = useSelector(getAcademyProfitability);
  const getYOYValues = useSelector(getYoyValues);
  const [t] = useTranslation();
  const club = useSelector(getClubValue);

  return (
    <div className="container">
      <div className="a commonBox box1">
        <LicenseMetrics
          title={club ? t('CLUB_TOTAL_ACADEMY_SPEND') : t('AVERAGE_TOTAL_ACADEMY_SPEND')}
          spendValue={academySpend?.value ? academySpend.value : '-'}
          metricsValue={getYOYValues.value1}
          showYen
          showYOY
        />
      </div>
      <div className="b commonBox box1">
        <LicenseMetrics
          title={club ? t('CLUB_SPEND_ON_ACADEMY') : t('AVERAGE_CLUB_SPEND_ON_ACADEMY')}
          spendValue={clubSpendonAcademy?.value ? clubSpendonAcademy.value + '%' : undefined}
          metricsValue={getYOYValues.value2}
          noClubLabel
          showYOY
        />
      </div>
      <div className="c commonBox box1">
        <LicenseMetrics
          title={club ? t('CLUB_ACADEMY_PROFITABILITY') : t('AVERAGE_ACADEMY_PROFITABILITY')}
          spendValue={academyProfit?.value ? academyProfit.value : '-'}
          metricsValue={getYOYValues.value3}
          customStyles={{ color: academyProfit?.value.includes('-') ? '#ed262c' : '#00864e' }}
          showYen
          showYOY
        />
      </div>
      <div className="d commonBox">
        <TimelineComponent page={PAGE.FINANCE} departments={[]}/>
        <RankingComponent page={PAGE.FINANCE} />
      </div>
      <div className="e commonBox">
        <ROIComponent page={PAGE.FINANCE} departments={[]}/>
      </div>
      <div className="f commonBox">
        <BenchMarkingComponent page={PAGE.FINANCE} departments={[]}/>
      </div>
    </div>
  );
});

export default FinanceLayoutPage;
